<template>
    <v-dialog v-model="dialog" width="800" persistent>
        <v-card v-if="item">
            <v-card-title>Historial de cambios</v-card-title>
            <v-card-text>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Origen</th>
                                <th>Destino</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(change, index) in item.schedule_changes" :key="index">
                                <td>{{ change.date }}</td>
                                <td>{{ change.from_course.name }}</td>
                                <td>{{ change.to_course.name }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="$parent.schedule_changes_dialog = false">Cerrar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:['item','dialog']
}
</script>